import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de seguir?',
    a: 'No, son alimentos comunes que encuentras en cualquier Mercadona o Lidl.'
  }, {
    q: '¿Tengo que cocinar mucho?',
    a: 'Son recetas simples de máximo 15 minutos.'
  }, {
    q: '¿Es seguro?',
    a: 'Es 100% natural, basado en comida real y técnicas de bienestar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-38">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-39">
        <FadeIn data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] text-center mb-12" data-id="element-41">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-43">
              <div className="bg-white rounded-2xl border border-[#E8EDE6] overflow-hidden" data-id="element-44">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-45">
                  <span className="font-bold text-lg text-[#2D2A26] font-serif" data-id="element-46">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#4A6741] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-47" />
                </button>
                <AnimatePresence data-id="element-48">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-49">
                      <div className="px-6 pb-5 text-[#6B6560] leading-relaxed" data-id="element-50">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}